/** A plain primary click: a middle, modified or right click has to reach the link's own target. */
export function isPlainClick(event: MouseEvent): boolean {
  return (
    event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
  );
}
